module.exports = __webpack_public_path__ + "media/icons/switch_black-17a4bf97.png";